import { render, staticRenderFns } from "./AppColorPicker.vue?vue&type=template&id=3ccb5064&scoped=true&"
import script from "./AppColorPicker.vue?vue&type=script&lang=ts&"
export * from "./AppColorPicker.vue?vue&type=script&lang=ts&"
import style0 from "./AppColorPicker.vue?vue&type=style&index=0&id=3ccb5064&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccb5064",
  null
  
)

export default component.exports